import backendService from '../../services/axios/tmsServiceBackend';
import qs from 'qs';

export default {
    get(params: Object) {
        return backendService.get('/drayage/orders', { params: params });
    },
    setPriority(params: Object) {
        return backendService.post('/drayage/orders/update/priority', qs.stringify(params));
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/services/drayage/order.ts